import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable()
export class LoaderService {
  isLoading = new Subject<boolean>();
  show() {
    //alert('Show');
    this.isLoading.next(true);
  }
  hide() {
    //alert('Close');
    this.isLoading.next(false);
  }
}
